<template>
    <div>
        <b-row>
            <b-col cols="12" class="mb-4"> <b-button variant="success" to="/admin/ratchet/create">{{ $t('add') }} </b-button> </b-col>
           
            <template v-if="items">
                <b-col cols="12" md="4" v-for="item in items" :key="item.id" @click="$router.push('/admin/ratchet/edit/' + item.id)">
                    <b-card>
                        <img :src="iconRender(item)" class="icon"/>
                        {{ item.id }}
                    </b-card>
                </b-col>
            </template>

            <template v-else>
                <b-col cols="12" md="4">
                    <b-skeleton width="100%" height="85px" animation="throb"></b-skeleton>
                </b-col>
                <b-col cols="12" md="4">
                    <b-skeleton width="100%" height="85px" animation="throb"></b-skeleton>
                </b-col>
            </template>
        </b-row>

    </div>
</template>

<script>
import mysqlIcon from '@/assets/ratchet/mysql.png'
import mongoIcon from '@/assets/ratchet/mongo.png'
import pgsqlIcon from '@/assets/ratchet/pgsql.png'
import bigqueryIcon from '@/assets/ratchet/bigquery.png'

export default {
    name: "RatchetList",
    components: {
        mysqlIcon,
        mongoIcon,
        pgsqlIcon,
        bigqueryIcon
    },
    data: function() {
        return {
            items: null
        }
    },

    methods: {
        iconRender(conn) {
            const icons = {
                'MySQL': mysqlIcon,
                'PostgreSQL': pgsqlIcon,
                'MongoDB': mongoIcon,
                'BigQuery': bigqueryIcon
            }

            return icons[conn.type]
        }
    },

    mounted() {
        this.$ratchetApi.get("/connection").then(resp => {
            this.items = resp.data
        }).catch(err => {
            this.$pageUnavailable()
        })
    }
}
</script>

<style scoped>
.icon {
    width: 40px;
    margin-right: 10px;
}
</style>